import http from './httpService';

/** AI-UX3 — Portal AI client (clientauth /api/client/ai). */

export function getPortalAiHealth() {
  return http.get('/client/ai/health');
}

export function listPortalAiThreads(params = {}) {
  return http.get('/client/ai/threads', { params });
}

export function createPortalAiThread(body) {
  return http.post('/client/ai/threads', body);
}

export function getPortalAiThread(id) {
  return http.get(`/client/ai/threads/${id}`);
}

export function postPortalAiThreadMessage(id, body) {
  return http.post(`/client/ai/threads/${id}/messages`, body);
}

export function askPortalAi(body) {
  return http.post('/client/ai/ask', body);
}
